import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation } from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function PartsToLaborRatio() {
    const [rosales, setROSales] = useState(0);
    const [laborsales, setLabourSales] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {
        setTotal(parseInt(rosales) / parseInt(laborsales));
    }, [rosales, laborsales])

    function clickResult() {
        history.push(
            {
                pathname: `/partstolaborratioresult?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        rosales: numberValidation,
        laborsales: numberValidation
    });

    const def = <span>Parts RO Sales &#247; Service Labor Sales</span>;

    return (
        <Formik
            initialValues={{ rosales: "", laborsales: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Parts To Labor Ratio</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="rosales">
                                            <Form.Label>Parts RO Sales</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="rosales" value={values.rosales} isInvalid={!!errors.rosales}
                                                onChange={e => { handleChange(e); setROSales(e.target.value) }} />
                                            <Form.Control.Feedback type="invalid">{errors.rosales}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="laborsales">
                                            <Form.Label>Service Labor Sales</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend> <InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                                <Form.Control size="lg" type="number" name="laborsales" value={values.laborsales} isInvalid={!!errors.laborsales}
                                                onChange={e => { handleChange(e); setLabourSales(e.target.value) }} />
                                            <Form.Control.Feedback type="invalid">{errors.laborsales}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function PartsToLaborRatioResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Parts To Labor Ratio";
    const total = urlParams.get('total') + ' : 1';
    const ratio = "1 : 1";

    const cond = parseFloat(total) >= 1;

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}


export {
    PartsToLaborRatio,
    PartsToLaborRatioResult
}